export const ARRIVAL_CRATE_MODAL = 'arrival_crate';
